export const LISTING_TYPE_HUMAN_NAME_MAP_SEARCH = {
  ALL: getText('Everything'),
  JOB: getText('Jobs'),
  INTERNSHIP: getText('Internships'),
  VOLOP: getText('Volunteer Opportunities'),
  ORG: getText('Organizations'),
  GRAD_PROGRAM: getText('Grad Programs'),
  USER: getText('Users'),
  INVOICE: getText('Invoices'),
  PAYMENT: getText('Payments'),
  DONATION: getText('Donations'),
  CMS_PAGE: getText('Articles'),
};
